<template>
  <div class="resource_geographical_layer">
    <div class="form-row">
      <div class="form-group col-12">
        <label :class="isFieldRequired('geographiclayer__display_name', formConfig.requiredFields) ? 'required' : ''">
          {{ $t('resource.geographicalDisplayName') }}
        </label>
        <ValidationProvider
          v-slot="{ classes, errors }"
          ref="geographical_display_label"
          :rules="isFieldRequired('geographiclayer__display_name', formConfig.requiredFields)"
          :name="$t('resource.geographicalDisplayName')"
        >
          <div
            class="control"
            :class="classes"
          >
            <input
              v-model="form.geographiclayerDisplayName"
              v-sanitize
              class="form-control"
              type="text"
              :placeholder="$t('resource.geographicalDisplayName')"
            >
            <span class="form-errors">{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
      </div>
    </div>
    <!-- <div class="form-row">
      <div
        :class="{ disabled: codenameDisabled }"
        class="form-group col-12"
      >
        <label :class="isFieldRequired('geographiclayer__codename', formConfig.requiredFields) ? 'required' : ''">
          {{ $t('resource.geographicalCodename') }}
        </label>
        <ValidationProvider
          v-slot="{ classes, errors }"
          ref="geographical_display_label"
          :rules="isFieldRequired('geographiclayer__codename', formConfig.requiredFields)"
          :name="$t('resource.geographicalCodename')"
        >
          <div
            class="control"
            :class="classes"
          >
            <input
              v-model="form.geographiclayerCodename"
              v-sanitize
              class="form-control"
              type="text"
              :placeholder="$t('resource.geographicalCodename')"
              :tabindex="codenameDisabled ? '-1' : ''"
            >
            <span class="form-errors">{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
      </div>
    </div> -->
    <div
      v-if="isXY"
      class="form-row"
    >
      <div class="form-group col-12">
        <label :class="isFieldRequired('column_x', formConfig.requiredFields) ? 'required' : ''">
          {{ $t('resource.XLon') }}
        </label>
        <ValidationProvider
          v-slot="{ classes, errors }"
          ref="geographical_column_x"
          :rules="isFieldRequired('column_x', formConfig.requiredFields)"
          :name="$t('resource.XLon')"
        >
          <div
            class="control"
            :class="classes"
          >
            <Multiselect
              v-if="xyColumnsOptions && xyColumnsOptions.length"
              v-model="form.columnX"
              :options="xyColumnsOptions.filter(el => el !== form.columnY)"
              select-label=""
              selected-label=""
              deselect-label=""
              :searchable="false"
              :placeholder="$t('resource.XLon')"
            />
            <input
              v-else
              v-model="form.columnX"
              v-sanitize
              class="form-control"
              type="text"
              :placeholder="$t('resource.XLon')"
            >
            <span class="form-errors">{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
      </div>
    </div>
    <div
      v-if="isXY"
      class="form-row"
    >
      <div class="form-group col-12">
        <label :class="isFieldRequired('column_y', formConfig.requiredFields) ? 'required' : ''">
          {{ $t('resource.YLon') }}
        </label>
        <ValidationProvider
          v-slot="{ classes, errors }"
          ref="geographical_column_y"
          :rules="isFieldRequired('column_y', formConfig.requiredFields)"
          :name="$t('resource.YLon')"
        >
          <div
            class="control"
            :class="classes"
          >
            <Multiselect
              v-if="xyColumnsOptions && xyColumnsOptions.length"
              v-model="form.columnY"
              :options="xyColumnsOptions.filter(el => el !== form.columnX)"
              select-label=""
              selected-label=""
              deselect-label=""
              :searchable="false"
              :placeholder="$t('resource.YLon')"
            />
            <input
              v-else
              v-model="form.columnY"
              v-sanitize
              class="form-control"
              type="text"
              :placeholder="$t('resource.YLon')"
            >
            <span class="form-errors">{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
      </div>
    </div>
    <div
      v-if="isXY"
      class="form-row"
    >
      <div class="form-group col-12">
        <label :class="isFieldRequired('crs', formConfig.requiredFields) ? 'required' : ''">
          {{ $t('resource.crs') }}
        </label>
        <ValidationProvider
          v-slot="{ classes, errors }"
          ref="geographical_display_label"
          :rules="isFieldRequired('crs', formConfig.requiredFields)"
          :name="$t('resource.crs')"
        >
          <div
            class="control"
            :class="classes"
          >
            <input
              v-model="form.crs"
              v-sanitize
              class="form-control"
              type="text"
              :placeholder="$t('resource.crs')"
            >
            <span class="form-errors">{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { ValidationProvider, extend, configure } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: 'Ce champ est requis'
});
configure({
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  }
});


export default {
  name: 'ResourceGeographicalLayer',

  components: {
    Multiselect,
    ValidationProvider
  },

  props: {
    formConfig: {
      type: Object,
      default: () => {}
    },
    geoData: {
      type: Object,
      default: () => {
        return {
          geographiclayerDisplayName: null,
          // geographiclayerCodename: null,
          columnX: null,
          columnY: null,
          crs: null
        };
      }
    },
    codenameDisabled: {
      type: Boolean,
      default: false
    },
    isXY: {
      type: Boolean,
      default: false
    },
    xyColumnsOptions: {
      type: Array,
      default: () => {
        return null;
      }
    }
  },

  data() {
    return {
      form: {
        geographiclayerDisplayName: null,
        // geographiclayerCodename: null,
        columnX: null,
        columnY: null,
        crs: null
      }
    };
  },

  watch: {
    form: {
      deep: true,
      handler(newValue) {
        this.setForm(newValue);
      }
    }
  },

  created() {
    this.setForm(this.geoData);
  },
  
  methods: {
    setForm(formData) {
      this.form.geographiclayerDisplayName = formData.geographiclayerDisplayName;
      // this.form.geographiclayerCodename = formData.geographiclayerCodename;
      this.form.columnX = formData.columnX;
      this.form.columnY = formData.columnY;
      this.form.crs = formData.crs;
      this.$emit('set', {
        form: this.form,
      });
    }
  }

};
</script>